module.exports = __webpack_public_path__ + "img/twitter.cf423516.svg";